/* tslint:disable */
/* eslint-disable */
/**
 * B2B Price Freeze
 * Endpoints to support Price Freeze  # Tracking Metrics * `b2bportal.availability.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.availability.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.booking.payment.error`   * tags: `api_version`, `error_code`, `payment`, `tenantid` * `b2bportal.booking.product.error`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.cancel.failure`   * tags: `api_version`, `cancel_scenario`, `error_code`, `product`, `tenantid` * `b2bportal.cancel.success`   * tags: `api_version`, `cancel_scenario`, `product`, `tenantid` * `b2bportal.mytrips.get.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.mytrips.get.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.price_freeze.offer.customize.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.price_freeze.offer.customize.success`   * tags: `api_version`, `tenantid` * `b2bportal.quote.cancel.product.failure`   * tags: `api_version`, `cancel_scenario`, `error_code`, `product`, `tenantid` * `b2bportal.quote.cancel.product.success`   * tags: `api_version`, `cancel_scenario`, `product`, `tenantid` * `b2bportal.quote.payment.error`   * tags: `api_version`, `error_code`, `payment`, `quote_action`, `tenantid` * `b2bportal.quote.product.error`   * tags: `api_version`, `error_code`, `product`, `quote_action`, `tenantid`   # Tracking Error Codes * `already_exchanged` * `already_exercised` * `bad_request` * `expired` * `ineligible` * `internal_error` * `no_availability` * `no_flights` * `not_enough_seats` * `not_found` * `offer_not_found` * `product_not_found` * `request_deserialization_error` * `response_serialization_error` * `unknown`
 *
 * The version of the OpenAPI document: v2p25
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

export interface AccountPrice {
    'currency': string;
    'value': number;
    'currencyDescription'?: string;
}
export interface Actions {
    'purchaseTime'?: string;
    'refund'?: Refund;
    'archiveTime'?: string;
    'transferTime'?: string;
}
export interface ActivePriceFreezes {
    'ListPriceFreezeRequest': ListPriceFreezeRequestEnum;
}


export interface Aircraft {
    'info': AmenityInfo;
}
export interface Airline {
    'displayName': string;
    'customHashTag'?: string;
    'fullName': string;
    'isLcc': boolean;
    'webLinks': WebLinks;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof Airline
     */
    'code': string;
    'cabinClassMappings': { [key: string]: HopperCabinClass; };
    'phone'?: string;
}
/**
 * `cityName` -  The name of the metropolitan area generally associated with the airport
   e.g. the YUL airport is in Dorval but should have cityName == "Montreal"
   e.g. the EWL airport serves New York City but it's still treated as belonging to Newark, so cityName == "Newark"
 * `servedCity` -  IATA has a concept of "served metropolitan area";
   e.g. Newark Intl Airport (EWR) is geographically in Newark but "serves" NYC
   This is a good presumed destination (for example for hotels or whatever)
   It is not however an acceptable display name for the airport (So we should not display EWR as "New York (EWR)")
 * `military` - military airports often place restrictions on international travelers
 * @export
 * @interface Airport
 */
export interface Airport {
    'coordinates': Coordinates;
    'servedCityName': string;
    'name': string;
    /**
     *  The name of the metropolitan area generally associated with the airport
   e.g. the YUL airport is in Dorval but should have cityName == "Montreal"
   e.g. the EWL airport serves New York City but it's still treated as belonging to Newark, so cityName == "Newark"
     * @type {string}
     * @memberof Airport
     */
    'cityName': string;
    /**
     * 3 character IATA city code
     * @type {string}
     * @memberof Airport
     */
    'servedCity': string;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof Airport
     */
    'code': string;
    'geography': GeopoliticalInfo;
    /**
     * military airports often place restrictions on international travelers
     * @type {boolean}
     * @memberof Airport
     */
    'military': boolean;
}
/**
 * When regionType is airport, code represents an IATA airport code and when regionType is city, code is an IATA city code
 * @export
 * @interface AirportRegion
 */
export interface AirportRegion {
    'regionType': RegionType;
    'code': string;
}


export interface AlreadyExchanged {
    'Failure': PriceFreezeRefundFailureEnum;
    'RefundPriceFreezeResponse': RefundPriceFreezeResponseEnum;
}


export interface AlreadyExercised {
    'Failure': PriceFreezeRefundFailureEnum;
    'RefundPriceFreezeResponse': RefundPriceFreezeResponseEnum;
}


export interface AmadeusBrand {
    'brandId': string;
    'brandName'?: string;
}
export interface Amenities {
    'seat': Seat;
    'aircraft': Aircraft;
    'entertainment': Entertainment;
    'beverage': Beverage;
    'wifi': Wifi;
    'layout': Layout;
    'power': Power;
    'freshFood': FreshFood;
}
export interface AmenitiesAndUtas {
    'amenities'?: Amenities;
    'utas': Utas;
    'upas': Array<Upa>;
}
export interface AmenitiesAndUtasV2 {
    'amenities'?: Amenities;
    'utas': UtasV2;
    'upas': Array<Upa>;
}
export const AmenityExists = {
    na: 'na',
    no: 'no',
    yes: 'yes'
} as const;

export type AmenityExists = typeof AmenityExists[keyof typeof AmenityExists];


export interface AmenityInfo {
    'displayText'?: string;
    'quality': AmenityQuality;
    'updatedAt'?: string;
}


export const AmenityQuality = {
    better: 'better',
    na: 'na',
    standard: 'standard'
} as const;

export type AmenityQuality = typeof AmenityQuality[keyof typeof AmenityQuality];


/**
 * A monetary amount
 * @export
 * @interface Amount
 */
export interface Amount {
    'amount': number;
    'currency': string;
}
export const AssessmentV2 = {
    Benefit: 'Benefit',
    Fee: 'Fee',
    Neutral: 'Neutral',
    Restriction: 'Restriction'
} as const;

export type AssessmentV2 = typeof AssessmentV2[keyof typeof AssessmentV2];


export interface Available {
    'offer': Offer;
    'GenerateCustomOfferResponse': GenerateCustomOfferResponseEnum;
}


export interface BagLimits {
    'weightKg'?: string;
    'sizeLcm'?: string;
}
export interface BaggageAllowance {
    'pieces': number;
    'descriptions': Array<string>;
    'maximumMass'?: Mass;
}
export interface BaggageCharge {
    'firstPiece': number;
    'amount': number;
    'maximumMass'?: Mass;
    'lastPiece': number;
    'currency': string;
    'descriptions': Array<string>;
}
/**
 * @type BaggageInfo
 * @export
 */
export type BaggageInfo = { BaggageInfo: 'Allowed' } & BaggageInfoAllowed | { BaggageInfo: 'NotAllowed' } & BaggageInfoNotAllowed | { BaggageInfo: 'Unknown' } & BaggageInfoUnknown;

export interface BaggageInfoAllowed {
    'allowance': BaggageAllowance;
    'charges': Array<BaggageCharge>;
    'BaggageInfo': BaggageInfoEnum;
}


export const BaggageInfoEnum = {
    Allowed: 'Allowed',
    NotAllowed: 'NotAllowed',
    Unknown: 'Unknown'
} as const;

export type BaggageInfoEnum = typeof BaggageInfoEnum[keyof typeof BaggageInfoEnum];


export interface BaggageInfoNotAllowed {
    'BaggageInfo': BaggageInfoEnum;
}


export interface BaggageInfoUnknown {
    'BaggageInfo': BaggageInfoEnum;
}


export interface Beverage {
    'info': AmenityInfo;
    'exists': AmenityExists;
}


/**
 * Contains the tripId and fareId
 * @export
 * @interface BookingDetails
 */
export interface BookingDetails {
    'tripId': string;
    'fareId': string;
}
export interface BookingInfo {
    'at': string;
    'sessionId'?: string;
    'itineraryId'?: string;
}
export const BrandType = {
    basicEconomy: 'basicEconomy',
    business: 'business',
    economy: 'economy',
    first: 'first',
    premiumEconomy: 'premiumEconomy',
    unknown: 'unknown'
} as const;

export type BrandType = typeof BrandType[keyof typeof BrandType];


export interface ByPriceFreezeId {
    /**
     * A Price Freeze identifier
     * @type {string}
     * @memberof ByPriceFreezeId
     */
    'id': string;
    'GetPriceFreezeRequest': GetPriceFreezeRequestEnum;
}


export interface ByShopQuery {
    'route': Route;
    'departureDate': string;
    'returnDate'?: string;
    'GetPriceFreezeRequest': GetPriceFreezeRequestEnum;
}


export interface Cap {
    'value': Amount;
}
/**
 * The Darmstadt configuration id used during Price Freeze booking
 * @export
 * @interface ConfigurationId
 */
export interface ConfigurationId {
    'timestamp': string;
}
export interface Coordinates {
    'lat': number;
    'lon': number;
}
export interface Cta {
    'text': string;
    'url': string;
}
/**
 * @type CurrentFareVersusCap
 * @export
 */
export type CurrentFareVersusCap = { CurrentFareVersusCap: 'FareOverCap' } & FareOverCap | { CurrentFareVersusCap: 'FareUnderCap' } & FareUnderCap;

export const CurrentFareVersusCapEnum = {
    FareOverCap: 'FareOverCap',
    FareUnderCap: 'FareUnderCap'
} as const;

export type CurrentFareVersusCapEnum = typeof CurrentFareVersusCapEnum[keyof typeof CurrentFareVersusCapEnum];


/**
 * When Status == IsActive
 * @export
 * @interface CurrentOfferActive
 */
export interface CurrentOfferActive {
    'RefreezeOffer': RefreezeOfferEnum;
}


export interface CurrentPriceFreezes {
    'ListPriceFreezeRequest': ListPriceFreezeRequestEnum;
}


export const Dealness = {
    fair: 'fair',
    good: 'good',
    great: 'great',
    wait: 'wait'
} as const;

export type Dealness = typeof Dealness[keyof typeof Dealness];


/**
 * A displayable monetary amount
 * @export
 * @interface DisplayAmount
 */
export interface DisplayAmount {
    'amount': Amount;
    'display': string;
}
export interface Entertainment {
    'info': AmenityInfo;
    'exists': AmenityExists;
}


export interface Expired {
    'Failure': PriceFreezeRefundFailureEnum;
    'RefundPriceFreezeResponse': RefundPriceFreezeResponseEnum;
}


export interface ExpiredPriceFreezes {
    'ListPriceFreezeRequest': ListPriceFreezeRequestEnum;
}


/**
 * @type Failure
 * @export
 */
export type Failure = { Failure: 'NotFound' } & NotFound;

export const FailureEnum = {
    NotFound: 'NotFound'
} as const;

export type FailureEnum = typeof FailureEnum[keyof typeof FailureEnum];


export interface Fare {
    'brandName': string;
    'brandCodes': Array<string>;
}
export interface FareBrand {
    'gdxFareBrand'?: GdxBrand;
    'amadeusFareBrand'?: AmadeusBrand;
    'navitaireNdcBrand'?: NavitaireNdcBrand;
    'travelportFareBrand'?: TravelportBrand;
    'sabreFareBrand'?: SabreBrand;
}
export interface FareDetails {
    'penaltiesInfo'?: PenaltiesInfo;
    'refundable'?: boolean;
    'paxPricings': Array<ShopTripPassengerPricing>;
    'timestamp': number;
    'took'?: number;
    'id': string;
    'conversationId': string;
    'slices': Array<FareSliceDetails>;
    'multiTicket': boolean;
    'fareScore'?: FareScore;
}
export interface FareDetailsV2 {
    'penaltiesInfo'?: PenaltiesInfo;
    'refundable'?: boolean;
    'paxPricings': Array<ShopTripPassengerPricing>;
    'timestamp': number;
    'took'?: number;
    'id': string;
    'conversationId': string;
    'slices': Array<FareSliceDetailsV2>;
    'multiTicket': boolean;
    'fareScore'?: FareScore;
}
export interface FareOverCap {
    'CurrentFareVersusCap': CurrentFareVersusCapEnum;
}


export interface FarePricing {
    'baseAmount': Prices;
    'taxAmount': Prices;
    'additionalMargin'?: Prices;
    'totalAmount': Prices;
}
export interface FareScore {
    'isFastest': boolean;
    'isBestQuality': boolean;
    'isCheapest': boolean;
    'comfort': number;
    'isBest': boolean;
    'value': number;
}
export interface FareSegment {
    'availableSeats': number;
}
export interface FareShelf {
    'outgoing': SegmentShelf;
    'returning'?: SegmentShelf;
}
export interface FareSlice {
    'segments': Array<FareSegment>;
    'brandType': BrandType;
}


export interface FareSliceDetails {
    'outgoing': boolean;
    'fareShelf'?: SegmentShelf;
    'fareDetails': ShopTripFareSlice;
    'amenitiesUtas'?: AmenitiesAndUtas;
}
export interface FareSliceDetailsV2 {
    'outgoing': boolean;
    'fareShelf'?: SegmentShelf;
    'fareDetails': ShopTripFareSlice;
    'amenitiesUtas'?: AmenitiesAndUtasV2;
}
export interface FareUnderCap {
    'CurrentFareVersusCap': CurrentFareVersusCapEnum;
}


export interface Fee {
    'currency': string;
    'price': number;
}
export interface FetchOfferRequest {
    'offerId': string;
}
export interface FetchOfferResponse {
    'offer': Offer;
}
/**
 * A cash amount
 * @export
 * @interface FiatPrice
 */
export interface FiatPrice {
    'currencyCode': string;
    'currencySymbol': string;
    'value': number;
}
export interface Flight {
    'slices': Array<Slice>;
    'fareDetails': Array<PriceFreezeFlightFare>;
}
export interface FreshFood {
    'info': AmenityInfo;
    'exists': AmenityExists;
}


/**
 * Flight fare information
 * @export
 * @interface FrozenFare
 */
export interface FrozenFare {
    'id': string;
    'paxPricings': Array<FrozenPassengerPricing>;
    'totalPricing'?: FrozenFarePricing;
}
export interface FrozenFarePricing {
    'originalAmount': Prices;
    'savingsAmount': Prices;
    'versusCap': CurrentFareVersusCap;
    'chargeAmount': Prices;
    'currentAmount': Prices;
    'increaseAmount': Prices;
}
export interface FrozenPassengerPricing {
    'paxType': string;
    'pricing': FrozenFarePricing;
    'quantity': number;
}
/**
 * SinglePassenger price to charge one passenger. The price will be provided by adult pricing, or else child pricing if no adults present, or else seated infant pricing.
 * @export
 * @interface FrozenPricingQuote
 */
export interface FrozenPricingQuote {
    'singlePassenger': Prices;
    'passengerQuantity': number;
}
export interface GdxBrand {
    'brandId': string;
    'brandName'?: string;
}
/**
 * `fareId` - The user selected fare id he selected. Optional for backwards compatibility.
 * @export
 * @interface GenerateCustomOfferRequest
 */
export interface GenerateCustomOfferRequest {
    'offerData': PriceFreezeOfferData;
    'tripId': string;
    'passengers': { [key: string]: number; };
    /**
     * The user selected fare id he selected. Optional for backwards compatibility.
     * @type {string}
     * @memberof GenerateCustomOfferRequest
     */
    'fareId'?: string;
}
/**
 * @type GenerateCustomOfferResponse
 * @export
 */
export type GenerateCustomOfferResponse = { GenerateCustomOfferResponse: 'Available' } & Available | { GenerateCustomOfferResponse: 'InvalidOfferData' } & InvalidOfferData | { GenerateCustomOfferResponse: 'NotAvailable' } & NotAvailable;

export const GenerateCustomOfferResponseEnum = {
    Available: 'Available',
    InvalidOfferData: 'InvalidOfferData',
    NotAvailable: 'NotAvailable'
} as const;

export type GenerateCustomOfferResponseEnum = typeof GenerateCustomOfferResponseEnum[keyof typeof GenerateCustomOfferResponseEnum];


export interface GeopoliticalInfo {
    /**
     * 2 character country code
     * @type {string}
     * @memberof GeopoliticalInfo
     */
    'countryCode': string;
    'regionCode'?: string;
    'currency': string;
    'timeZone': string;
}
export interface GetNearExpirationPriceFreezes {
    'ListPriceFreezeRequest': ListPriceFreezeRequestEnum;
}


/**
 * @type GetPriceFreezeFailure
 * @export
 */
export type GetPriceFreezeFailure = { Failure: 'NotFound' } & NotFound;

export const GetPriceFreezeFailureEnum = {
    NotFound: 'NotFound'
} as const;

export type GetPriceFreezeFailureEnum = typeof GetPriceFreezeFailureEnum[keyof typeof GetPriceFreezeFailureEnum];


/**
 * @type GetPriceFreezeRequest
 * @export
 */
export type GetPriceFreezeRequest = { GetPriceFreezeRequest: 'ByPriceFreezeId' } & ByPriceFreezeId | { GetPriceFreezeRequest: 'ByShopQuery' } & ByShopQuery;

export const GetPriceFreezeRequestEnum = {
    ByPriceFreezeId: 'ByPriceFreezeId',
    ByShopQuery: 'ByShopQuery'
} as const;

export type GetPriceFreezeRequestEnum = typeof GetPriceFreezeRequestEnum[keyof typeof GetPriceFreezeRequestEnum];


/**
 * @type GetPriceFreezeResponse
 * @export
 */
export type GetPriceFreezeResponse = { GetPriceFreezeResponse: 'Failure' } & Failure | { GetPriceFreezeResponse: 'Success' } & Success;

export const GetPriceFreezeResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type GetPriceFreezeResponseEnum = typeof GetPriceFreezeResponseEnum[keyof typeof GetPriceFreezeResponseEnum];


/**
 * @type GetPriceFreezeResponseV2
 * @export
 */
export type GetPriceFreezeResponseV2 = { GetPriceFreezeResponseV2: 'Failure' } & GetPriceFreezeFailure | { GetPriceFreezeResponseV2: 'Success' } & GetPriceFreezeSuccess;

export const GetPriceFreezeResponseV2Enum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type GetPriceFreezeResponseV2Enum = typeof GetPriceFreezeResponseV2Enum[keyof typeof GetPriceFreezeResponseV2Enum];


export interface GetPriceFreezeSuccess {
    'priceFreeze': PriceFreezeViewV2;
    'tripContext': TripContext;
    'priceDropProtection': PriceDropProtection;
    'GetPriceFreezeResponseV2': GetPriceFreezeResponseV2Enum;
}


export const HopperCabinClass = {
    Business: 'Business',
    Economy: 'Economy',
    First: 'First',
    PremiumEconomy: 'PremiumEconomy',
    Unknown: 'Unknown'
} as const;

export type HopperCabinClass = typeof HopperCabinClass[keyof typeof HopperCabinClass];


export interface Icon {
    'smallIconUrl': string;
    'largeIconUrl': string;
}
export interface Interval {
    'dates': string;
    'copy': string;
}
export interface Intervals {
    'normal'?: Interval;
    'warning'?: Interval;
    'danger'?: Interval;
}
export interface InvalidOfferData {
    'offerData': PriceFreezeOfferData;
    'GenerateCustomOfferResponse': GenerateCustomOfferResponseEnum;
}


export interface IsActive {
    'Status': StatusEnum;
}


export interface IsEligible {
    'candidateId': string;
    'PriceDropProtection': PriceDropProtectionEnum;
    'trackingPropertiesV2': TrackingProperties;
    'maximumRefund': PriceDropMaximumRefund;
    'minimumRefund': PriceDropMinimumRefund;
    'monitoringDuration': PriceDropMonitoringDuration;
}


export interface IsExpired {
    'Status': StatusEnum;
}


/**
 * @type Itinerary
 * @export
 */
export type Itinerary = { Itinerary: 'MultiItinerary' } & MultiItinerary | { Itinerary: 'SingleItinerary' } & SingleItinerary;

export const ItineraryEnum = {
    MultiItinerary: 'MultiItinerary',
    SingleItinerary: 'SingleItinerary'
} as const;

export type ItineraryEnum = typeof ItineraryEnum[keyof typeof ItineraryEnum];


export interface Layout {
    'info': AmenityInfo;
}
/**
 * @type ListPriceFreezeRequest
 * @export
 */
export type ListPriceFreezeRequest = { ListPriceFreezeRequest: 'ActivePriceFreezes' } & ActivePriceFreezes | { ListPriceFreezeRequest: 'CurrentPriceFreezes' } & CurrentPriceFreezes | { ListPriceFreezeRequest: 'ExpiredPriceFreezes' } & ExpiredPriceFreezes | { ListPriceFreezeRequest: 'GetNearExpirationPriceFreezes' } & GetNearExpirationPriceFreezes;

export const ListPriceFreezeRequestEnum = {
    ActivePriceFreezes: 'ActivePriceFreezes',
    CurrentPriceFreezes: 'CurrentPriceFreezes',
    ExpiredPriceFreezes: 'ExpiredPriceFreezes',
    GetNearExpirationPriceFreezes: 'GetNearExpirationPriceFreezes'
} as const;

export type ListPriceFreezeRequestEnum = typeof ListPriceFreezeRequestEnum[keyof typeof ListPriceFreezeRequestEnum];


export interface ListPriceFreezeResponse {
    'priceFreezes': Array<PriceFreezeView>;
    'tripContext': TripContext;
}
export interface ListPriceFreezeResponseV2 {
    'priceFreezes': Array<PriceFreezeViewV2>;
    'tripContext': TripContext;
}
export interface Mass {
    'value': number;
    'unit': string;
}
export interface MultiItinerary {
    'tripIds': Array<string>;
    'Itinerary': ItineraryEnum;
}


export interface MultiPolicyV2 {
    'afterDeparture'?: PolicyV2;
    'anytime'?: PolicyV2;
    'beforeDeparture'?: PolicyV2;
}
export interface NavitaireNdcBrand {
    'brandId'?: string;
    'brandName': string;
}
/**
 * Failed to generate a new offer
 * @export
 * @interface NoOfferAvailable
 */
export interface NoOfferAvailable {
    'RefreezeOffer': RefreezeOfferEnum;
}


export interface NotAvailable {
    'GenerateCustomOfferResponse': GenerateCustomOfferResponseEnum;
}


export interface NotEligible {
    'reason'?: string;
    'PriceDropProtection': PriceDropProtectionEnum;
}


export interface NotEnoughSeats {
    'PriceFreezeError': PriceFreezeErrorEnum;
}


export interface NotFound {
    'Failure': FailureEnum;
    'GetPriceFreezeResponse': GetPriceFreezeResponseEnum;
}


export interface Offer {
    'seatedPassengers': { [key: string]: number; };
    'voidWindowAvailabilityEnd': VoidWindowAvailabilityEnd;
    'passengers': { [key: string]: number; };
    'totalAmount': Prices;
    'id': string;
    'timeToLive': TimeToLive;
    'perPaxAmount': Prices;
    'cap': Cap;
}
export interface OfferNotFound {
    'PriceFreezeError': PriceFreezeErrorEnum;
}


export interface OfferWithSuggested {
    'offer': Offer;
    'tripToRefreeze': Trip;
}
export interface PassengerPricing {
    'paxType': string;
    'pricing': FarePricing;
    'quantity': number;
}
/**
 * @type PenaltiesInfo
 * @export
 */
export type PenaltiesInfo = { PenaltiesInfo: 'ExternallyManaged' } & PenaltiesInfoExternallyManaged | { PenaltiesInfo: 'Known' } & PenaltiesInfoKnown | { PenaltiesInfo: 'Unknown' } & PenaltiesInfoUnknown;

export const PenaltiesInfoEnum = {
    ExternallyManaged: 'ExternallyManaged',
    Known: 'Known',
    Unknown: 'Unknown'
} as const;

export type PenaltiesInfoEnum = typeof PenaltiesInfoEnum[keyof typeof PenaltiesInfoEnum];


export interface PenaltiesInfoExternallyManaged {
    'code': string;
    'PenaltiesInfo': PenaltiesInfoEnum;
}


export interface PenaltiesInfoKnown {
    'changePenalty': Penalty;
    'cancelPenalty': Penalty;
    'PenaltiesInfo': PenaltiesInfoEnum;
}


export interface PenaltiesInfoUnknown {
    'PenaltiesInfo': PenaltiesInfoEnum;
}


/**
 * @type Penalty
 * @export
 */
export type Penalty = { Penalty: 'NoPenalty' } & PenaltyNoPenalty | { Penalty: 'NotPossible' } & PenaltyNotPossible | { Penalty: 'Unknown' } & PenaltyUnknown | { Penalty: 'WithFee' } & PenaltyWithFee;

export const PenaltyEnum = {
    NoPenalty: 'NoPenalty',
    NotPossible: 'NotPossible',
    Unknown: 'Unknown',
    WithFee: 'WithFee'
} as const;

export type PenaltyEnum = typeof PenaltyEnum[keyof typeof PenaltyEnum];


export interface PenaltyNoPenalty {
    'Penalty': PenaltyEnum;
}


export interface PenaltyNotPossible {
    'Penalty': PenaltyEnum;
}


export interface PenaltyUnknown {
    'Penalty': PenaltyEnum;
}


export interface PenaltyWithFee {
    'amount': number;
    'currency': string;
    'Penalty': PenaltyEnum;
}


export interface Policy {
    'headline': string;
    'description'?: string;
    'assessment': string;
    'fee'?: Fee;
}
export interface PolicyV2 {
    'headline': string;
    'description'?: string;
    'assessment': AssessmentV2;
    'fee'?: Fee;
}


export interface Power {
    'info': AmenityInfo;
    'exists': AmenityExists;
}


export interface Prediction {
    'predictionCopy'?: PredictionCopy;
    'recommendation': Recommendation;
    'lowestPrice': Prices;
    'PredictionResult': PredictionResultEnum;
    'priceDropProtection': PriceDropProtection;
    'pricePrediction': PricePrediction;
    'dealness': Dealness;
}


export interface PredictionCopy {
    'recommendationBodyWatching': Array<string>;
    'carrier': string;
    'recommendationTitleWatching': Array<string>;
    'intervals': Intervals;
    'recommendationBody': Array<string>;
    'lowestPriceLabel': string;
    'recommendationTitleJustWatched': Array<string>;
    'lowestPrice': string;
    'recommendationBodyJustWatched': Array<string>;
    'travelDates': string;
    'origin': string;
    'recommendationTitle': Array<string>;
    'dealness': string;
    'destination': string;
}
/**
 * @type PredictionResult
 * @export
 */
export type PredictionResult = { PredictionResult: 'Prediction' } & Prediction | { PredictionResult: 'UnavailablePrediction' } & UnavailablePrediction;

export const PredictionResultEnum = {
    Prediction: 'Prediction',
    UnavailablePrediction: 'UnavailablePrediction'
} as const;

export type PredictionResultEnum = typeof PredictionResultEnum[keyof typeof PredictionResultEnum];


/**
 * Offer generated, but previous frozen trip is not available. FE will land user on the flight light
 * @export
 * @interface PreviousTripUnavailable
 */
export interface PreviousTripUnavailable {
    'tripSummaries': Array<TripSummary>;
    'prediction': PredictionResult;
    'priceFreezeOffer': OfferWithSuggested;
    'RefreezeOffer': RefreezeOfferEnum;
}


export interface PriceDropMaximumRefund {
    'display': string;
    'amount': Amount;
}
export interface PriceDropMinimumRefund {
    'display': string;
    'amount': Amount;
}
export interface PriceDropMonitoringDuration {
    'inSeconds': number;
}
/**
 * @type PriceDropProtection
 * @export
 */
export type PriceDropProtection = { PriceDropProtection: 'IsEligible' } & IsEligible | { PriceDropProtection: 'NotEligible' } & NotEligible;

export const PriceDropProtectionEnum = {
    IsEligible: 'IsEligible',
    NotEligible: 'NotEligible'
} as const;

export type PriceDropProtectionEnum = typeof PriceDropProtectionEnum[keyof typeof PriceDropProtectionEnum];


export interface PriceFreeze {
    'externalId': string;
    'expiresAt': string;
    /**
     * A Price Freeze identifier
     * @type {string}
     * @memberof PriceFreeze
     */
    'id': string;
    'actions': Actions;
    'offer': Offer;
}
/**
 * @type PriceFreezeError
 * @export
 */
export type PriceFreezeError = { PriceFreezeError: 'NotEnoughSeats' } & NotEnoughSeats | { PriceFreezeError: 'OfferNotFound' } & OfferNotFound | { PriceFreezeError: 'PriceFreezeErrorCode' } & PriceFreezeErrorCode | { PriceFreezeError: 'ProductNotFound' } & ProductNotFound;

export interface PriceFreezeErrorCode {
    'code': string;
    'message'?: string;
    'PriceFreezeError': PriceFreezeErrorEnum;
}


export const PriceFreezeErrorEnum = {
    NotEnoughSeats: 'NotEnoughSeats',
    OfferNotFound: 'OfferNotFound',
    PriceFreezeErrorCode: 'PriceFreezeErrorCode',
    ProductNotFound: 'ProductNotFound'
} as const;

export type PriceFreezeErrorEnum = typeof PriceFreezeErrorEnum[keyof typeof PriceFreezeErrorEnum];


/**
 * Details on a price freeze exercise discount applied to a trip

 * `priceFreezeId` - The Price Freeze being exercised
 * `frozenPricePerPax` - The frozen price for a single passenger
 * `frozenPaxCount` - The number of frozen passengers
 * `capPerPax` - The maximum coverage of the price freeze for a single passenger
 * `discountPerPax` - The price freeze exercise discount amount for a single passenger
 * `totalDiscountAmount` - The total price freeze exercise discount amount
 * @export
 * @interface PriceFreezeExerciseDiscount
 */
export interface PriceFreezeExerciseDiscount {
    /**
     * A Price Freeze identifier
     * @type {string}
     * @memberof PriceFreezeExerciseDiscount
     */
    'priceFreezeId': string;
    'frozenPricePerPax': Prices;
    /**
     * The number of frozen passengers
     * @type {number}
     * @memberof PriceFreezeExerciseDiscount
     */
    'frozenPaxCount': number;
    'capPerPax'?: Prices;
    'discountPerPax': Prices;
    'totalDiscountAmount': Prices;
}
/**
 * Request to add price freeze exercise discount to a trip. If priceFreeze in not specified service will try to find a price freeze that is applicable to the trip
 * @export
 * @interface PriceFreezeExerciseDiscountUpdate
 */
export interface PriceFreezeExerciseDiscountUpdate {
    /**
     * A Price Freeze identifier
     * @type {string}
     * @memberof PriceFreezeExerciseDiscountUpdate
     */
    'priceFreeze': string;
}
export interface PriceFreezeFlightAirline {
    'code': string;
    'name': string;
}
export interface PriceFreezeFlightFare {
    'id': string;
    'paxPricings': Array<PassengerPricing>;
    'totalPricing'?: FarePricing;
}
export interface PriceFreezeFlightPaymentFinalizeResult {
    'priceFreeze': PriceFreeze;
    'frozenFlight': Flight;
    'frozenFare': PriceFreezeFlightFare;
    'attachedEmail': string;
}
export interface PriceFreezeOfferData {
    'secondsTtl': number;
    'price': Prices;
    'trackingProperties': TrackingProperties;
    'modelName': string;
    'cap': Prices;
}
export interface PriceFreezeOfferDataRequest {
    'departureDate': string;
    'tripId': string;
    'fareId': string;
}
export interface PriceFreezeOfferDataResponse {
    'offerData': Array<PriceFreezeOfferData>;
    'trackingProperties': TrackingProperties;
}
/**
 * @type PriceFreezeRefundFailure
 * @export
 */
export type PriceFreezeRefundFailure = { Failure: 'AlreadyExchanged' } & AlreadyExchanged | { Failure: 'AlreadyExercised' } & AlreadyExercised | { Failure: 'Expired' } & Expired | { Failure: 'NotFound' } & PriceFreezeRefundNotFound | { Failure: 'Unknown' } & Unknown;

export const PriceFreezeRefundFailureEnum = {
    AlreadyExchanged: 'AlreadyExchanged',
    AlreadyExercised: 'AlreadyExercised',
    Expired: 'Expired',
    NotFound: 'NotFound',
    Unknown: 'Unknown'
} as const;

export type PriceFreezeRefundFailureEnum = typeof PriceFreezeRefundFailureEnum[keyof typeof PriceFreezeRefundFailureEnum];


export interface PriceFreezeRefundNotFound {
    /**
     * A Price Freeze identifier
     * @type {string}
     * @memberof PriceFreezeRefundNotFound
     */
    'id': string;
    'Failure': PriceFreezeRefundFailureEnum;
    'RefundPriceFreezeResponse': RefundPriceFreezeResponseEnum;
}


export interface PriceFreezeRefundSuccess {
    'RefundPriceFreezeResponse': RefundPriceFreezeResponseEnum;
}


export interface PriceFreezeView {
    'frozenFlight': Flight;
    'bookingDetails': BookingDetails;
    'frozenFare': FrozenFare;
    'status': Status;
    'refreezeOffer'?: RefreezeOffer;
    'tripDetails': TripDetails;
    'priceFreeze': PriceFreeze;
    'purchasePricing'?: PurchasePricing;
}
/**
 * `frozenFlight` - Minimal flight information
 * `bookingDetails` - Contains the tripId and fareId
 * `frozenFare` - Flight fare information
 * `status` - Status of the Price freeze
 * `refreezeOffer` - New generated offer to freeze price again
 * `purchasePricing` - Contains the tripId and fareId
 * @export
 * @interface PriceFreezeViewV2
 */
export interface PriceFreezeViewV2 {
    'frozenFlight': Flight;
    'bookingDetails': BookingDetails;
    'trackingProperties': TrackingProperties;
    'frozenFare': FrozenFare;
    'status': Status;
    'refreezeOffer'?: RefreezeOffer;
    'tripDetails': TripDetailsV2;
    'priceFreeze': PriceFreeze;
    'purchasePricing'?: PurchasePricing;
}
export interface PricePrediction {
    'minPrice'?: DisplayAmount;
    'maxPrice'?: DisplayAmount;
}
/**
 * Price Freeze quote that is passed opaquely to the frontend in the Purchase API quote
 * @export
 * @interface PriceQuoteData
 */
export interface PriceQuoteData {
    /**
     * A Price Freeze identifier
     * @type {string}
     * @memberof PriceQuoteData
     */
    'priceFreezeId': string;
    'configurationId': ConfigurationId;
    'totalAmount': Prices;
    'perPaxAmount': Prices;
    'offer': Offer;
    'frozenPricing': FrozenPricingQuote;
}
/**
 * Price in fiat currency as well as any with rewards/account specific currency
 * @export
 * @interface Prices
 */
export interface Prices {
    'fiat': FiatPrice;
    'accountSpecific': { [key: string]: AccountPrice; };
}
export interface ProductNotFound {
    'PriceFreezeError': PriceFreezeErrorEnum;
}


/**
 * Contains the tripId and fareId
 * @export
 * @interface PurchasePricing
 */
export interface PurchasePricing {
    'total': Total;
}
export const Recommendation = {
    Buy: 'Buy',
    Wait: 'Wait'
} as const;

export type Recommendation = typeof Recommendation[keyof typeof Recommendation];


/**
 * @type RefreezeOffer
 * New generated offer to freeze price again
 * @export
 */
export type RefreezeOffer = { RefreezeOffer: 'CurrentOfferActive' } & CurrentOfferActive | { RefreezeOffer: 'NoOfferAvailable' } & NoOfferAvailable | { RefreezeOffer: 'PreviousTripUnavailable' } & PreviousTripUnavailable | { RefreezeOffer: 'RefreezeTrip' } & RefreezeTrip;

export const RefreezeOfferEnum = {
    CurrentOfferActive: 'CurrentOfferActive',
    NoOfferAvailable: 'NoOfferAvailable',
    PreviousTripUnavailable: 'PreviousTripUnavailable',
    RefreezeTrip: 'RefreezeTrip'
} as const;

export type RefreezeOfferEnum = typeof RefreezeOfferEnum[keyof typeof RefreezeOfferEnum];


/**
 * Offer is generated and previously frozen trip found. FE will land user on confirmation screen
 * @export
 * @interface RefreezeTrip
 */
export interface RefreezeTrip {
    'tripSummaries': Array<TripSummary>;
    'prediction': PredictionResult;
    'priceFreezeOffer': OfferWithSuggested;
    'RefreezeOffer': RefreezeOfferEnum;
}


export interface Refund {
    'at': string;
    'bookingInfo': BookingInfo;
    'amount': Prices;
}
export interface RefundPriceFreezeRequest {
    /**
     * A Price Freeze identifier
     * @type {string}
     * @memberof RefundPriceFreezeRequest
     */
    'id': string;
}
/**
 * @type RefundPriceFreezeResponse
 * @export
 */
export type RefundPriceFreezeResponse = { RefundPriceFreezeResponse: 'Failure' } & PriceFreezeRefundFailure | { RefundPriceFreezeResponse: 'Success' } & PriceFreezeRefundSuccess;

export const RefundPriceFreezeResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type RefundPriceFreezeResponseEnum = typeof RefundPriceFreezeResponseEnum[keyof typeof RefundPriceFreezeResponseEnum];


export const RegionType = {
    airport: 'airport',
    city: 'city'
} as const;

export type RegionType = typeof RegionType[keyof typeof RegionType];


/**
 * A description of a route's origin and destination
 * @export
 * @interface Route
 */
export interface Route {
    'origin': AirportRegion;
    'destination': AirportRegion;
}
export interface SabreBrand {
    'brandId': string;
    'brandName'?: string;
}
/**
 * Request a Price Quote

 * `total` - Total price across all passengers that was displayed to the user. Only optional for compatablity. Should always be populated.
 * @export
 * @interface SchedulePriceQuoteRequest
 */
export interface SchedulePriceQuoteRequest {
    /**
     * A phone Number. The frontend should validate the phone number since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof SchedulePriceQuoteRequest
     */
    'phoneNumber': string;
    'offerId': string;
    'passengers': { [key: string]: number; };
    /**
     * An email address that matches given regex pattern. The frontend should validate the emails address since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof SchedulePriceQuoteRequest
     */
    'emailAddress': string;
    'shouldIgnoreQuote'?: boolean;
    'total'?: Amount;
    'itinerary': Itinerary;
    'quoteTokenKey'?: TokenKey;
}
export interface Seat {
    'flatness': SeatFlatness;
    'info': AmenityInfo;
    'pitch': string;
    'legroom': SeatLegroom;
    'width': SeatWidth;
}


export const SeatFlatness = {
    angle_flat: 'angle_flat',
    full_flat: 'full_flat',
    na: 'na',
    not_flat: 'not_flat'
} as const;

export type SeatFlatness = typeof SeatFlatness[keyof typeof SeatFlatness];


export const SeatLegroom = {
    less: 'less',
    more: 'more',
    na: 'na',
    standard: 'standard'
} as const;

export type SeatLegroom = typeof SeatLegroom[keyof typeof SeatLegroom];


export const SeatWidth = {
    na: 'na',
    standard: 'standard',
    wider: 'wider'
} as const;

export type SeatWidth = typeof SeatWidth[keyof typeof SeatWidth];


export interface Segment {
    'departureTime': string;
    'airlineName': string;
    'airlineCode': string;
    'zonedDepartureTime': string;
    'zonedArrivalTime': string;
    'plusDays': number;
    'marketingAirline': PriceFreezeFlightAirline;
    'arrivalTime': string;
    'destinationName': string;
    'originCode': string;
    'originName': string;
    'stopoverDurationMinutes'?: number;
    'operatingAirline': PriceFreezeFlightAirline;
    'flightNumber': string;
    'destinationCode': string;
}
export interface SegmentShelf {
    'rating': number;
    'brandName': string;
    'shortBrandName': string;
    'opaqueMapperStep'?: string;
}
export interface ShopSummaryAirline {
    'code': string;
    'name': string;
}
export interface ShopTripFarePricing {
    'baseAmount': Prices;
    'additionalMargin'?: Prices;
    'lastTicketDate'?: string;
    'total': Prices;
    'taxAmount': Prices;
}
export interface ShopTripFareSegment {
    'penaltiesInfo': PenaltiesInfo;
    'ticketIndex'?: number;
    'outgoing': boolean;
    'brand'?: FareBrand;
    'carrierCabinClass'?: string;
    'code'?: string;
    'codes': { [key: string]: string; };
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof ShopTripFareSegment
     */
    'validatingCarrierCode'?: string;
    'bookingCode'?: string;
    'privateFare'?: boolean;
    'connection'?: boolean;
    'availableSeats': number;
    'baggageInfo': BaggageInfo;
    'cabinClassName'?: string;
}
export interface ShopTripFareSlice {
    'segments': Array<ShopTripFareSegment>;
}
export interface ShopTripPassengerPricing {
    'paxType': string;
    'pricing': ShopTripFarePricing;
    'quantity': number;
}
export interface SingleItinerary {
    'tripId': string;
    'fareId': string;
    'Itinerary': ItineraryEnum;
}


export interface Slice {
    'departureTime': string;
    'zonedDepartureTime': string;
    'outgoing': boolean;
    'arrivalTime': string;
    'destinationName': string;
    'originCode': string;
    'segmentDetails': Array<Segment>;
    'originName': string;
    'totalDurationMinutes': number;
    'destinationCode': string;
    'stops': number;
}
/**
 * @type Status
 * Status of the Price freeze
 * @export
 */
export type Status = { Status: 'IsActive' } & IsActive | { Status: 'IsExpired' } & IsExpired;

export const StatusEnum = {
    IsActive: 'IsActive',
    IsExpired: 'IsExpired'
} as const;

export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];


export interface Success {
    'priceFreeze': PriceFreezeView;
    'tripContext': TripContext;
    'priceDropProtection': PriceDropProtection;
    'GetPriceFreezeResponse': GetPriceFreezeResponseEnum;
}


export interface TimeToLive {
    'inSeconds': number;
    'inHours'?: number;
    'inDays'?: number;
}
export interface TokenKey {
    'userId': string;
    'sessionId': string;
}
export interface Total {
    'fiatAmount'?: FiatPrice;
    'accountSpecificAmount'?: AccountPrice;
}
export interface TrackingProperties {
    'properties'?: any;
    'encryptedProperties'?: string;
}
export interface TravelportBrand {
    'brandId': string;
    'brandName'?: string;
    'brandTier'?: number;
}
export interface Trip {
    'tripId': string;
    'fareId': string;
}
export interface TripContext {
    'airports': { [key: string]: Airport; };
    'airlines': { [key: string]: Airline; };
}
export interface TripDetails {
    'pointOfSaleCountryCode': string;
    'fareDetails': Array<FareDetails>;
    'id': string;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof TripDetails
     */
    'validatingCarrierCode'?: string;
    'tripDescription': string;
    'slices': Array<TripSlice>;
}
export interface TripDetailsV2 {
    'pointOfSaleCountryCode': string;
    'fareDetails': Array<FareDetailsV2>;
    'id': string;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof TripDetailsV2
     */
    'validatingCarrierCode'?: string;
    'tripDescription': string;
    'slices': Array<TripSlice>;
}
export interface TripFare {
    'fareShelf'?: FareShelf;
    'isMultiTicket': boolean;
    'brandType': BrandType;
    'lastTicketDate'?: string;
    'fareId': string;
    'amount': Prices;
    'slices': Array<FareSlice>;
    'fareScore': FareScore;
}


export interface TripSegment {
    'departureTime': string;
    'airlineName': string;
    'airlineCode': string;
    'zonedDepartureTime': string;
    'zonedArrivalTime': string;
    'plusDays': number;
    'marketingAirline': ShopSummaryAirline;
    'arrivalTime': string;
    'destinationName': string;
    'originCode': string;
    'originName': string;
    'stopoverDurationMinutes'?: number;
    'operatingAirline': ShopSummaryAirline;
    'flightNumber': string;
    'destinationCode': string;
}
export interface TripSlice {
    'departureTime': string;
    'zonedDepartureTime': string;
    'outgoing': boolean;
    'arrivalTime': string;
    'destinationName': string;
    'originCode': string;
    'id': string;
    'segmentDetails': Array<TripSegment>;
    'originName': string;
    'totalDurationMinutes': number;
    'destinationCode': string;
    'stops': number;
}
export interface TripSummary {
    /**
     * 2 character country code
     * @type {string}
     * @memberof TripSummary
     */
    'domestic'?: string;
    'tripFares': Array<TripFare>;
    'context': TripContext;
    'tripId': string;
    'outgoingSlice': TripSlice;
    'returningSlice'?: TripSlice;
}
/**
 * When a flight cannot be currently voided
 * @export
 * @interface Unavailable
 */
export interface Unavailable {
    'VoidWindowAvailabilityEnd': VoidWindowAvailabilityEndEnum;
}


export interface UnavailablePrediction {
    'reason': string;
    'PredictionResult': PredictionResultEnum;
}


export interface Unknown {
    'message': string;
    'Failure': PriceFreezeRefundFailureEnum;
    'RefundPriceFreezeResponse': RefundPriceFreezeResponseEnum;
}


/**
 * When a flight currently has a void window, with information about when it ends
 * @export
 * @interface Until
 */
export interface Until {
    'time': string;
    'VoidWindowAvailabilityEnd': VoidWindowAvailabilityEndEnum;
}


export interface Upa {
    'headline': string;
    'description': string;
    'icon'?: Icon;
    'cta'?: Cta;
    'category': UpaCategory;
}


export const UpaCategory = {
    brand: 'brand',
    promotion: 'promotion',
    promotion_position1: 'promotion-position1',
    unrecognized: 'unrecognized'
} as const;

export type UpaCategory = typeof UpaCategory[keyof typeof UpaCategory];


export interface Uta {
    'headline': string;
    'description': string;
    'icon'?: Icon;
    'bagLimits': BagLimits;
    'cta'?: Cta;
    'category': UtaCategory;
    'assessment': UtaAssessment;
}


export const UtaAssessment = {
    benefit: 'benefit',
    fee: 'fee',
    neutral: 'neutral',
    restriction: 'restriction'
} as const;

export type UtaAssessment = typeof UtaAssessment[keyof typeof UtaAssessment];


export const UtaCategory = {
    advance_change: 'advance-change',
    boarding_priority: 'boarding-priority',
    cancellation: 'cancellation',
    carry_on_allowance: 'carry-on-allowance',
    check_in_priority: 'check-in-priority',
    checked_bag_allowance: 'checked-bag-allowance',
    lounge_access: 'lounge-access',
    personal_item: 'personal-item',
    refundable_fare: 'refundable-fare',
    same_day_change: 'same-day-change',
    seat_selection: 'seat-selection',
    upgrade_eligibility: 'upgrade-eligibility'
} as const;

export type UtaCategory = typeof UtaCategory[keyof typeof UtaCategory];


export interface Utas {
    'fare'?: Fare;
    'utas': Array<Uta>;
    'changePolicy'?: Policy;
    'cancellationPolicy'?: Policy;
}
export interface UtasV2 {
    'fare'?: Fare;
    'utas': Array<Uta>;
    'changePolicy'?: MultiPolicyV2;
    'cancellationPolicy'?: MultiPolicyV2;
}
/**
 * @type VoidWindowAvailabilityEnd
 * Information about availability of a void window for a flight (=cancellable)
 * @export
 */
export type VoidWindowAvailabilityEnd = { VoidWindowAvailabilityEnd: 'Unavailable' } & Unavailable | { VoidWindowAvailabilityEnd: 'Until' } & Until;

export const VoidWindowAvailabilityEndEnum = {
    Unavailable: 'Unavailable',
    Until: 'Until'
} as const;

export type VoidWindowAvailabilityEndEnum = typeof VoidWindowAvailabilityEndEnum[keyof typeof VoidWindowAvailabilityEndEnum];


export interface WebLinks {
    'changeCancelPolicy'?: string;
    'otherFee'?: string;
    'checkInPolicy'?: string;
    'wifiFee'?: string;
    'homePage'?: string;
    'baggageFees'?: string;
    'seatUpgrade'?: string;
    'manageBooking'?: string;
    'seatSelection'?: string;
}
export interface Wifi {
    'info': AmenityInfo;
    'exists': AmenityExists;
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get Price Freeze
         * @param {GetPriceFreezeRequest} getPriceFreezeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PricefreezeGetPost: async (getPriceFreezeRequest: GetPriceFreezeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getPriceFreezeRequest' is not null or undefined
            assertParamExists('apiV0PricefreezeGetPost', 'getPriceFreezeRequest', getPriceFreezeRequest)
            const localVarPath = `/api/v0/pricefreeze/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPriceFreezeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List Price Freeze Offers
         * @param {ListPriceFreezeRequest} listPriceFreezeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PricefreezeListPost: async (listPriceFreezeRequest: ListPriceFreezeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listPriceFreezeRequest' is not null or undefined
            assertParamExists('apiV0PricefreezeListPost', 'listPriceFreezeRequest', listPriceFreezeRequest)
            const localVarPath = `/api/v0/pricefreeze/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listPriceFreezeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Price Freeze Offer Data
         * @param {PriceFreezeOfferDataRequest} priceFreezeOfferDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PricefreezeOfferCustomDataPost: async (priceFreezeOfferDataRequest: PriceFreezeOfferDataRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'priceFreezeOfferDataRequest' is not null or undefined
            assertParamExists('apiV0PricefreezeOfferCustomDataPost', 'priceFreezeOfferDataRequest', priceFreezeOfferDataRequest)
            const localVarPath = `/api/v0/pricefreeze/offer/custom/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(priceFreezeOfferDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate Custom Price Freeze Offer
         * @param {GenerateCustomOfferRequest} generateCustomOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PricefreezeOfferCustomPost: async (generateCustomOfferRequest: GenerateCustomOfferRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateCustomOfferRequest' is not null or undefined
            assertParamExists('apiV0PricefreezeOfferCustomPost', 'generateCustomOfferRequest', generateCustomOfferRequest)
            const localVarPath = `/api/v0/pricefreeze/offer/custom`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateCustomOfferRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Price Freeze Offer
         * @param {FetchOfferRequest} fetchOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PricefreezeOfferGetPost: async (fetchOfferRequest: FetchOfferRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fetchOfferRequest' is not null or undefined
            assertParamExists('apiV0PricefreezeOfferGetPost', 'fetchOfferRequest', fetchOfferRequest)
            const localVarPath = `/api/v0/pricefreeze/offer/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fetchOfferRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refund Price Freeze
         * @param {RefundPriceFreezeRequest} refundPriceFreezeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PricefreezeRefundPost: async (refundPriceFreezeRequest: RefundPriceFreezeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refundPriceFreezeRequest' is not null or undefined
            assertParamExists('apiV0PricefreezeRefundPost', 'refundPriceFreezeRequest', refundPriceFreezeRequest)
            const localVarPath = `/api/v0/pricefreeze/refund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refundPriceFreezeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Price Freeze
         * @param {GetPriceFreezeRequest} getPriceFreezeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PricefreezeGetPost: async (getPriceFreezeRequest: GetPriceFreezeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getPriceFreezeRequest' is not null or undefined
            assertParamExists('apiV2PricefreezeGetPost', 'getPriceFreezeRequest', getPriceFreezeRequest)
            const localVarPath = `/api/v2/pricefreeze/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPriceFreezeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List Price Freeze Offers
         * @param {ListPriceFreezeRequest} listPriceFreezeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PricefreezeListPost: async (listPriceFreezeRequest: ListPriceFreezeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listPriceFreezeRequest' is not null or undefined
            assertParamExists('apiV2PricefreezeListPost', 'listPriceFreezeRequest', listPriceFreezeRequest)
            const localVarPath = `/api/v2/pricefreeze/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listPriceFreezeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Get Price Freeze
         * @param {GetPriceFreezeRequest} getPriceFreezeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PricefreezeGetPost(getPriceFreezeRequest: GetPriceFreezeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPriceFreezeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PricefreezeGetPost(getPriceFreezeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List Price Freeze Offers
         * @param {ListPriceFreezeRequest} listPriceFreezeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PricefreezeListPost(listPriceFreezeRequest: ListPriceFreezeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPriceFreezeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PricefreezeListPost(listPriceFreezeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get Price Freeze Offer Data
         * @param {PriceFreezeOfferDataRequest} priceFreezeOfferDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PricefreezeOfferCustomDataPost(priceFreezeOfferDataRequest: PriceFreezeOfferDataRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceFreezeOfferDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PricefreezeOfferCustomDataPost(priceFreezeOfferDataRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Generate Custom Price Freeze Offer
         * @param {GenerateCustomOfferRequest} generateCustomOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PricefreezeOfferCustomPost(generateCustomOfferRequest: GenerateCustomOfferRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateCustomOfferResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PricefreezeOfferCustomPost(generateCustomOfferRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get Price Freeze Offer
         * @param {FetchOfferRequest} fetchOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PricefreezeOfferGetPost(fetchOfferRequest: FetchOfferRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchOfferResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PricefreezeOfferGetPost(fetchOfferRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Refund Price Freeze
         * @param {RefundPriceFreezeRequest} refundPriceFreezeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PricefreezeRefundPost(refundPriceFreezeRequest: RefundPriceFreezeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefundPriceFreezeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PricefreezeRefundPost(refundPriceFreezeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get Price Freeze
         * @param {GetPriceFreezeRequest} getPriceFreezeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PricefreezeGetPost(getPriceFreezeRequest: GetPriceFreezeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPriceFreezeResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PricefreezeGetPost(getPriceFreezeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List Price Freeze Offers
         * @param {ListPriceFreezeRequest} listPriceFreezeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PricefreezeListPost(listPriceFreezeRequest: ListPriceFreezeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPriceFreezeResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2PricefreezeListPost(listPriceFreezeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Get Price Freeze
         * @param {GetPriceFreezeRequest} getPriceFreezeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PricefreezeGetPost(getPriceFreezeRequest: GetPriceFreezeRequest, options?: any): AxiosPromise<GetPriceFreezeResponse> {
            return localVarFp.apiV0PricefreezeGetPost(getPriceFreezeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List Price Freeze Offers
         * @param {ListPriceFreezeRequest} listPriceFreezeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PricefreezeListPost(listPriceFreezeRequest: ListPriceFreezeRequest, options?: any): AxiosPromise<ListPriceFreezeResponse> {
            return localVarFp.apiV0PricefreezeListPost(listPriceFreezeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Price Freeze Offer Data
         * @param {PriceFreezeOfferDataRequest} priceFreezeOfferDataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PricefreezeOfferCustomDataPost(priceFreezeOfferDataRequest: PriceFreezeOfferDataRequest, options?: any): AxiosPromise<PriceFreezeOfferDataResponse> {
            return localVarFp.apiV0PricefreezeOfferCustomDataPost(priceFreezeOfferDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate Custom Price Freeze Offer
         * @param {GenerateCustomOfferRequest} generateCustomOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PricefreezeOfferCustomPost(generateCustomOfferRequest: GenerateCustomOfferRequest, options?: any): AxiosPromise<GenerateCustomOfferResponse> {
            return localVarFp.apiV0PricefreezeOfferCustomPost(generateCustomOfferRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Price Freeze Offer
         * @param {FetchOfferRequest} fetchOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PricefreezeOfferGetPost(fetchOfferRequest: FetchOfferRequest, options?: any): AxiosPromise<FetchOfferResponse> {
            return localVarFp.apiV0PricefreezeOfferGetPost(fetchOfferRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Refund Price Freeze
         * @param {RefundPriceFreezeRequest} refundPriceFreezeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PricefreezeRefundPost(refundPriceFreezeRequest: RefundPriceFreezeRequest, options?: any): AxiosPromise<RefundPriceFreezeResponse> {
            return localVarFp.apiV0PricefreezeRefundPost(refundPriceFreezeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Price Freeze
         * @param {GetPriceFreezeRequest} getPriceFreezeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PricefreezeGetPost(getPriceFreezeRequest: GetPriceFreezeRequest, options?: any): AxiosPromise<GetPriceFreezeResponseV2> {
            return localVarFp.apiV2PricefreezeGetPost(getPriceFreezeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List Price Freeze Offers
         * @param {ListPriceFreezeRequest} listPriceFreezeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PricefreezeListPost(listPriceFreezeRequest: ListPriceFreezeRequest, options?: any): AxiosPromise<ListPriceFreezeResponseV2> {
            return localVarFp.apiV2PricefreezeListPost(listPriceFreezeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Get Price Freeze
     * @param {GetPriceFreezeRequest} getPriceFreezeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PricefreezeGetPost(getPriceFreezeRequest: GetPriceFreezeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PricefreezeGetPost(getPriceFreezeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List Price Freeze Offers
     * @param {ListPriceFreezeRequest} listPriceFreezeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PricefreezeListPost(listPriceFreezeRequest: ListPriceFreezeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PricefreezeListPost(listPriceFreezeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Price Freeze Offer Data
     * @param {PriceFreezeOfferDataRequest} priceFreezeOfferDataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PricefreezeOfferCustomDataPost(priceFreezeOfferDataRequest: PriceFreezeOfferDataRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PricefreezeOfferCustomDataPost(priceFreezeOfferDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate Custom Price Freeze Offer
     * @param {GenerateCustomOfferRequest} generateCustomOfferRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PricefreezeOfferCustomPost(generateCustomOfferRequest: GenerateCustomOfferRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PricefreezeOfferCustomPost(generateCustomOfferRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Price Freeze Offer
     * @param {FetchOfferRequest} fetchOfferRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PricefreezeOfferGetPost(fetchOfferRequest: FetchOfferRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PricefreezeOfferGetPost(fetchOfferRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refund Price Freeze
     * @param {RefundPriceFreezeRequest} refundPriceFreezeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PricefreezeRefundPost(refundPriceFreezeRequest: RefundPriceFreezeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PricefreezeRefundPost(refundPriceFreezeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Price Freeze
     * @param {GetPriceFreezeRequest} getPriceFreezeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV2PricefreezeGetPost(getPriceFreezeRequest: GetPriceFreezeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV2PricefreezeGetPost(getPriceFreezeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List Price Freeze Offers
     * @param {ListPriceFreezeRequest} listPriceFreezeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV2PricefreezeListPost(listPriceFreezeRequest: ListPriceFreezeRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV2PricefreezeListPost(listPriceFreezeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



